import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../router/Routes';
import ContainerTemplate from '../../widgets/template/Container';
import DashboardAdminBandaView from './DashboardAdminBandaView';
import DashboardAdminView from './DashboardAdminView';
import DashboardCPanelView from './DashboardCPanelView';
import DashboardDocentesView from './DashboardDocentesView';

async function clearLocalStorage() {
  localStorage.clear();
}

const DashboardModule = () => {
  const history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  function getView() {
    if (entidadesStore.settings.isBanda) return <DashboardAdminBandaView />;
    if (loginStore.isRoot) return <DashboardCPanelView />;
    if (loginStore.isAdmin) return <DashboardAdminView />;
    if (loginStore.isTeacher) return <DashboardDocentesView />;
  }

  try {
    return (
      <ContainerTemplate active={ROUTES.dashboard} routes={[]}>
        {(entidadesStore.activo !== null || loginStore.isRoot) && getView()}
      </ContainerTemplate>
    );
  } catch (error) {
    clearLocalStorage();
    alert('Sesión inesperada, vuelva a intentarlo.');
    history.push('/login');
  }
};

export default DashboardModule;
